<template>
  <div class="Aviso">
    <div class="banner">
      <headNav :activeNav="'Aviso'"></headNav>
      <div class="title">Aviso de Privacidad</div>
    </div>
    <div class="bigContent">
      <div>
        <p>Fecha de Actualización: 6 de agosto de 2025</p>
        <p class="title">
          1. Política de Privacidad y Tratamiento de datos personales en la plataforma LUCKYPLATA y sitios relacionados
        </p>
        <p>
          La presente política tiene como objetivo proteger el derecho constitucional del Habeas Data que tienen todas
          las personas para conocer , actualizar y rectificar la información que se haya recogido y almacenado en las
          distintas bases de datos de LUCKYPLATA y en virtud del cumplimiento de dicho derecho sólo recolecta y da
          tratamiento a Datos Personales, cuando así haya sido autorizado previamente por su titular, implementando las
          medias de seguridad necesarias para proteger datos personales. Tambiés expone los lineamientos que se tienen
          en cuenta para las finalidades del tratamiento de la información el área responsable de atender quejasy
          reclamos y los procedimientos para actualizar, rectificar y suprimir la información y los respetivos canales
          para que estos puedan ejercerlos.
        </p>
        <p>
          “LUCKYPLATA”, en esa medida la recolección y tratamiento de tus datos personales, así como el de nuestros
          clientes, usuarios y empleados está sujeta a las normas vigentes en la República de Colombia sobre protección
          de datos personales.
        </p>
        <p>
          El usuario no puede hacer la solicitud a través de la Website, solo vía app por lo que necesita descargarla.
          Al navegar o usar la aplicación para dispositivos móviles, reconoce que ha leído, entendido y se obliga a
          cumplir con la presente Política de Protección de Tratamiento de Datos Personales de LUCKYPLATA, con los
          términos y condiciones de la compañía, y cumplir con todas las leyes y reglamentos aplicables en la materia,
          si el usuario no está de acuerdo con los términos y condiciones de uso o con cualquier disposición de la
          política de privacidad y tratamiento de datos personales, le sugerimos que se abstenga de acceder o usar
          nuestra aplicación para dispositivos móviles, y de usar los productos y servicios que se presentan en el
          mismo.
        </p>
        <p class="title">¿QUÉ DATOS PERSONALES USAMOS</p>
        <p>
          LUCKYPLATA recabará de ti (en adelante el “Titular” o “tú”) los siguientes datos personales (en lo sucesivo
          los “datos” o los “datos personales”) en tu calidad de uno de nuestros clientes:
        </p>
        <p>- datos de contacto (número de teléfono celular, correo electrónico, domicilio personal);</p>
        <p>
          - datos de identificación (nombre, fecha de nacimiento, captura de imagen, identificación oficial, género
          asignado);
        </p>
        <p>- datos biométricos;</p>
        <p>
          - Descripción de la información de la fotografía del retrato del usuario: esta información solo se utiliza
          para identificar al usuario durante operaciones clave, como las financieras. El propósito es prevenir el
          fraude y no se usará ni compartirá para otros fines.
        </p>
        <p>- datos de localización y geolocalización (ubicación aproximada, huso horario);</p>
        <p>- datos laborales y educativos;</p>
        <p>
          - datos de comunicación con LUCKYPLATA (solicitudes de atención al cliente, respuestas a aclaraciones u otras
          comunicaciones a través de mensajes SMS, correo electrónico o grabación de llamadas);
        </p>
        <p>
          - datos de tu teléfono celular o dispositivo móvil (información del hardware, dirección IP, GPS ADID o
          identificación de otro dispositivo, operador móvil);
        </p>
        <p>- datos de uso de tu dispositivo (lista de aplicaciones instaladas, datos de cuentas);</p>
        <p>- datos de SMS (la marca de tiempo, el número de teléfono y el contenido del SMS);</p>
        <p>- lista de contactos, SMS que envías, registro y frecuencia de llamada de tu teléfono móvil;</p>
        <p>
          - datos patrimoniales y financieros (ingresos o datos o documentos de tu empleo, grado de escolaridad,
          propósito o uso que se le dará al préstamo);
        </p>
        <p>
          - información crediticia del titular, obtenida de las sociedades de información crediticia autorizadas en
          Colombia: esta información se utiliza exclusivamente para la verificación del estado crediticio personal del
          titular, sin fines adicionales;
        </p>
        <p>- datos que proporciones en tu solicitud de préstamo;</p>
        <p>
          - datos transaccionales de las operaciones que realizas con nosotros o a través de nosotros, así como de las
          operaciones que realizas con transmisores de dinero, instituciones de fondos de pago electrónico,
          instituciones de financiamiento colectivo, instituciones de crédito y otras instituciones financieras o
          comercios electrónicos; y
        </p>
        <p>
          - datos de uso de la aplicación de LUCKYPLATA y de otras aplicaciones (detalles de instalación, tráfico,
          navegación).
        </p>
        <p>
          - Recopilamos el ID de publicidad de Google para brindarte una experiencia publicitaria personalizada. Al
          analizar tus intereses y comportamientos, los anuncios serán más relevantes y efectivos, adaptándose mejor a
          tus necesidades.
        </p>
        <p class="title">¿USAMOS DATOS PERSONALES SENSIBLES?</p>
        <p>
          LUCKYPLATA no solicita directamente datos raciales o de origen étnico, de salud, creencias filosóficas o
          religiosas, afiliación sindical, opiniones políticas, preferencias sexuales (salvo por tu género asignado que
          se requiere para temas de prevención de lavado de dinero). Sin embargo, recabamos información relacionadav con
          tu lista de contactos, SMS, registro de SMS e imágenes que incidentalmente puede tener datos personales
          sensibles.
        </p>
        <p class="title">NECESIDAD DE LA RECOLECCIÓN Y PROCESAMIENTO DE TUS DATOS</p>
        <p>
          LUCKYPLATA te informa que los datos personales y personales sensibles (recolectados incidentalmente) que te
          solicita, de conformidad con el presente Aviso de Privacidad, son necesarios y suficientes para que LUCKYPLATA
          realice un proceso de evaluación de riesgo de crédito y probabilidad de pago (scoring crediticio) en base a tu
          perfil y así poder determinar tu capacidad crediticia, lo cual es la base fundamental de la determinación de
          LUCKYPLATA para aprobar o rechazar el otorgamiento de tu solicitud de crédito y dar inicio a la relación
          jurídica contigo, así como para las demás finalidades primarias y secundarias que se señalan en el presente
          Aviso de Privacidad. Cabe resaltar que, la decisión final al respecto no es tomada de forma manual por un
          oficial o empleado de LUCKYPLATA, sino que, dicha decisión es tomada por los sistemas automatizados de
          LUCKYPLATA de conformidad con lo señalado en la sección “Decisiones Automatizadas” del presente Aviso de
          Privacidad.
        </p>
        <p class="title">¿CÓMO OBTENEMOS Y ACTUALIZAMOS TUS DATOS?</p>
        <p>Los datos personales serán obtenidos y actualizados a través de:</p>
        <p>1. Ti, cuando bajas la aplicación de LUCKYPLATA y/o nos solicitas un préstamo;</p>
        <p>
          2. Tus otras interacciones con nosotros, incluyendo datos personales que voluntariamente compartes con nuestro
          departamento de atención al cliente o con nuestros empleados y agentes;
        </p>
        <p>3. Tu teléfono celular o dispositivo móvil cuando otorgas acceso y permisos que se describe abajo;</p>
        <p>4. Buros de crédito o agencias para prevenir el fraude;</p>
        <p>5. Cookies, web beacons y otros medios remotos de recolección automática de datos;</p>
        <p>
          6. Transmisores de dinero instituciones de fondos de pago electrónico, instituciones de financiamiento
          colectivo, instituciones de crédito y otras instituciones financieras y comercios electrónicos, con tu
          consentimiento, cuando sea necesario; y/o
        </p>
        <p>
          7. Sociedades de información crediticia autorizadas en Colombia, con tu consentimiento previo y expreso, para
          la obtención de tu información crediticia; y/o
        </p>
        <p>8. Terceros y otras fuentes públicas, con tu consentimiento, cuando sea necesario.</p>
        <p class="title">¿PARA QUÉ USAMOS TUS DATOS?</p>
        <p>
          Las finalidades primarias (en lo sucesivo, las “Finalidades Primarias”) que dan origen y son necesarias para
          el mantenimiento y cumplimiento de la relación jurídica entre LUCKYPLATA y tú son las siguientes:
        </p>
        <p>
          - Verificar tu identidad, prevenir fraudes y cumplir con nuestras obligaciones de “conoce a tu cliente” bajo
          las leyes aplicables de prevención de lavado de dinero;
        </p>
        <p>
          - Crear tu perfil crediticio y asignarte una calificación crediticia para determinar si eres elegible para
          usar los productos y servicios de LUCKYPLATA;
        </p>
        <p>
          - Llevar a cabo la identificación y el conocimiento mediante recolección de datos personales, así como la
          integración de tu expediente que se mantendrá en la infraestructura tecnológica y sistemas de información de
          LUCKYPLATA y en otros archivos;
        </p>
        <p>
          - Incorporar los datos personales en instrumentos jurídicos, dar cumplimiento a los contratos que celebres con
          LUCKYPLATA, incluyendo, pero no limitado a ciertos contratos de usuario de nuestra aplicación y plataformas y
          los contratos de préstamo o crédito entre el Titular y LUCKYPLATA y administrar y manejar dichos contratos;
        </p>
        <p>- Originar, gestionar, dar servicio, mantener y exigir las deudas del Titular;</p>
        <p>- Brindarte servicios y gestionar tu cuenta con LUCKYPLATA y darte soporte como cliente;</p>
        <p>
          - Enviarte información de transacciones o notificaciones de transacciones, recordatorios de pago y anuncios a
          través de servicios de telefonía automáticos o mensajes pre-grabados, SMS o email;
        </p>
        <p>
          - Ceder o transmitir a un tercero, mediante cualquier medio, los derechos y/u obligaciones derivadas de los
          contratos antes señalados;
        </p>
        <p>
          - Utilizar los datos personales, en cualquier tipo de acto o diligencia de cobranza judicial o extrajudicial;
        </p>
        <p>- Cumplir con todas las leyes, reglamentos y disposiciones de carácter general aplicables;</p>
        <p>- Investigar cambios en tu perfil transaccional;</p>
        <p>- Prevención de fraudes;</p>
        <p>
          - Obtener datos personales para mejorar los modelos crediticios de LUCKYPLATA, sus modelos de datos y otros
          servicios; y
        </p>
        <p>- Analizar el comportamiento del cliente y mantener la calidad de nuestros servicios.</p>
        <p>
          Las finalidades secundarias (en lo sucesivo, las “Finalidades Secundarias”) que no son necesarias para el
          mantenimiento y cumplimiento de la relación jurídica entre LUCKYPLATA y tú, son las siguientes:
        </p>
        <p>- Envío de noticias, invitaciones a eventos de LUCKYPLATA y/o sus empresas subsidiarias y afiliadas;</p>
        <p>- Realización de encuestas para mejorar nuestro servicio;</p>
        <p>- Uso de imágenes y testimonios que nos proporciones voluntariamente para fines publicitarios; y</p>
        <p>
          - La mercadotecnia, publicidad y/o promoción de los productos y/o servicios que sean ofrecidos por LUCKYPLATA
          al Titular, por cualquier medio material y/o electrónico. Con tu consentimiento al presente Aviso de
          Privacidad otorgas tu consentimiento expreso para que podamos contactarte con la finalidad de ofrecerte
          servicios financieros.
        </p>
        <p>
          Utilizamos Adjust,Appsflyer como plataforma de atribución de anuncios para ayudarnos a evaluar el rendimiento
          de los anuncios y optimizar la inversión publicitaria. A través de Adjust,Appsflyer , recopilamos y analizamos
          los siguientes datos de los usuarios:
        </p>
        <p>
          - Clics en anuncios y conversiones: Seguimiento de los clics en los anuncios y la instalación de la
          aplicación.
        </p>
        <p>
          - Información del dispositivo: Incluye el modelo del dispositivo, versión del sistema operativo, dirección IP,
          etc.
        </p>
        <p>
          - Datos de comportamiento del usuario: Seguimiento de las interacciones y actividades del usuario dentro de la
          aplicación.
        </p>
        <p>
          Nota importante: No recopilamos datos sensibles de los usuarios. Los datos recopilados nos ayudan a mejorar
          nuestra estrategia publicitaria y ofrecer una mejor experiencia de usuario.
        </p>
        <p>
          Tu consentimiento es necesario para las finalidades secundarias. Si no estás de acuerdo con el uso de tus
          datos de contacto para dichas finalidades secundarias, envíanos un correo a luckyplataatc@gmail.com.
          Esperaremos cinco días hábiles antes de usar tus datos personales para finalidades secundarias.
        </p>
        <p class="title">¿A QUÉ PERMISOS EN TU DISPOSITIVO ACCEDE LUCKYPLATA?</p>
        <p>
          Dependiendo de tu sistema operativo Android y de la versión de la aplicación instalada en tu dispositivo, la
          aplicación de LUCKYPLATA puede acceder a los siguientes permisos del dispositivo. Mantén siempre actualizada
          tu aplicación de LUCKYPLATA para que puedas utilizar las funcionalidades más recientes y seguras.
        </p>
        <p>
          - Permiso de SMS: LUCKYPLATA accederá a la información de los SMS almacenados en su dispositivo (incluyendo
          marca temporal, número de teléfono y contenido del mensaje). Los criterios de filtrado requieren que el
          mensaje contenga palabras clave relacionadas con temas financieros, como cash, tasa, efectivo, money,
          bancaria, entre otros. Solo recopilaremos y monitorizaremos los mensajes de su bandeja de entrada relacionados
          con finanzas para garantizar la precisión de los datos y la seguridad de su privacidad. Todos los datos de SMS
          serán cifrados por la aplicación y cargados en los servidores, donde se filtrarán y procesarán para eliminar
          los mensajes irrelevantes.Propósito: esto nos ayuda a identificar las diversas cuentas bancarias que los
          usuarios pueden tener, sus patrones de flujo de efectivo, descripciones y determinar la cantidad de
          transacciones que pueden asistirle. LUCKYPLATA utiliza esta información en sus modelos de crédito y
          aseguramiento para determinar si eres elegible para nuestro servicio. Utilizamos el procesamiento automatizado
          para entender tu actividad financiera, y esto también ayuda a nuestros modelos de fraude a verificar tu
          identidad. Realizamos evaluaciones de riesgo crediticio para poder determinar el perfil de riesgo del usuario
          y brindarle un análisis crediticio adecuado. Este proceso le permite obtener un financiamiento de las
          entidades financieras reguladas disponibles en la plataforma.Almacenamiento de datos SMS: los datos SMS se
          cifrarán y cargarán en nuestro servidor miembro
          <span style="color: #0000ff">https://api.luckyplata.co</span> y
          <span style="color: #0000ff">https://rcdept.luckyplata.co</span> a través del protocolo HTTPS. En ningún
          momento compartiremos estos datos con terceros.
        </p>
        <p>
          - Listado de app instaladas - Recopilar y controlar información relacionada con su capacidad informada en la
          aplicación, y cifrada subirlo a en nuestro servidor y nuestro proveedor externo
          <span style="color: #0000ff">https://api.luckyplata.co</span> y
          <span style="color: #0000ff">https://rcdept.luckyplata.co</span>
        </p>
        <p>
          - Cámara – LUCKYPLATA te pedirá que subas fotos de tu identificación. LUCKYPLATA también puede pedirte que
          subas copias de documentos para acreditar tus ingresos.
        </p>
        <p>
          - Leer el estado del teléfono y la identidad – Cuando te registras para obtener una cuenta de LUCKYPLATA,
          LUCKYPLATA recupera tu número de teléfono de tu dispositivo automáticamente. Esto asegura que el número de
          teléfono celular está activo y es correcto, y que está vinculado al dispositivo que estás usando para abrir la
          cuenta.
        </p>
        <p>
          - Ejecutar al inicio – Esto permite que la aplicación de LUCKYPLATA envíe notificaciones a tu dispositivo
          cuando lo reinicies.
        </p>
        <p>
          - Ver y cambiar la conectividad de la red – Esto se utiliza para notificar a la aplicación de LUCKYPLATA
          cuando la conectividad de la red cambie para que podamos determinar si estás conectado a Internet o no.
        </p>
        <p>
          - Ver conexiones Wi-Fi – LUCKYPLATA utiliza la dirección IP y el tipo de red de tu dispositivo para detectar y
          prevenir fraudes.
        </p>
        <p>
          - Recibir datos de internet – LUCKYPLATA necesita este permiso para enviar solicitudes a través de la
          aplicación de LUCKYPLATA y para permitir que dicha aplicación acceda a internet.
        </p>
        <p>
          - Evitar que el teléfono entre en modo inactivo – Este permiso es requerido por algunas de las características
          y servicios dentro de la aplicación de LUCKYPLATA, como los mensajes enviados por la propia aplicación.
        </p>
        <p>
          - Ubicación - Recopile y supervise información sobre la ubicación de su dispositivo para proporcionar la
          facilidad de servicio de su solicitud de préstamo y también proporcione ofertas personalizadas.
        </p>
        <p>
          - Teléfono - Recopile y supervise información específica sobre su dispositivo, incluido el modelo de hardware,
          el sistema operativo y la versión, el identificador único del dispositivo, la información del perfil de
          usuario, la información de wi-fi, la información de la red móvil para identificar de forma exclusiva los
          dispositivos y garantizar que los dispositivos no autorizados no puedan actuar en su nombre, lo que nos ayuda
          a prevenir fraudes.
        </p>
        <p>- Almacenamiento - Le permite cargar documentos e imágenes para la solicitud de préstamo.</p>
        <p class="title">¿CON QUIÉN COMPARTIMOS SUS DATOS?</p>
        <p>
          Los datos personales se transferirán a nivel nacional e internacional, a las personas o entidades ubicadas en
          los siguientes tipos, categorías o sectores, con las siguientes finalidades:
        </p>
        <p>
          <span class="title">A. </span>A otras sociedades controladoras, subsidiarias o afiliadas, o a una sociedad
          matriz o a cualquier sociedad del mismo grupo de LUCKYPLATA, que operen bajo los mismos procesos y políticas
          internas, con la finalidad de hacer uso de servicios compartidos dentro del grupo de LUCKYPLATA y además para:
        </p>
        <p>
          i. Llevar a cabo la identificación y el conocimiento mediante recolección de datos personales del Titular, así
          como la integración de los datos personales en la infraestructura tecnológica de LUCKYPLATA, así como en sus
          sistemas de información y otros archivos;
        </p>
        <p>
          i.i Incorporar los datos personales del Titular en instrumentos jurídicos, dar cumplimiento a las obligaciones
          del Titular bajo los contratos celebrados entre el Titular y LUCKYPLATA, incluyendo de manera enunciativa, más
          no limitativa, ciertos contratos de usuario de nuestra aplicación y plataformas y los contratos de préstamo o
          crédito entre el Titular y LUCKYPLATA y administrar y manejar dichos contratos;
        </p>
        <p>
          iii. Ceder o transmitir a un tercero, mediante cualquier medio, los derechos y/u obligaciones derivadas de los
          contratos antes señalados;
        </p>
        <p>
          iv. Utilizar los datos personales, en cualquier tipo de acto o diligencia de cobranza judicial o
          extrajudicial;
        </p>
        <p>Cumplir con todas las leyes, reglamentos y disposiciones de carácter general aplicables;</p>
        <p>
          vi. Prospectar y evaluar los datos personales para crear y asignar al titular una calificación crediticia o
          grado de calificación similar.
        </p>
        <p>vii. Obtener información para mejorar nuestro modelo crediticio, de datos y de servicios;</p>
        <p>viii. Investigar cambios en tu perfil transaccional;</p>
        <p>ix. Prevención de fraudes;</p>
        <p>x. Originar, gestionar, dar servicio, mantener y exigir la deuda del Titular.</p>
        <p>
          <span class="title">B. </span>A autoridades nacionales y extranjeras competentes, con la finalidad de dar
          cumplimiento a alguna ley, reglamento o disposición legal aplicable, así como con la finalidad de prevenir un
          daño.
        </p>
        <p>
          <span class="title">C. </span>A terceros que adquieran la cartera crediticia de LUCKYPLATA o que otorguen
          financiamiento a LUCKYPLATA con la finalidad de que LUCKYPLATA pueda obtener financiamiento o recursos.
        </p>
        <p>
          <span class="title">D. </span>A terceros interesados en otorgar financiamientos o adquirir las acciones o
          activos de LUCKYPLATA o de sus accionistas o filiales en Colombia o alrededor del mundo o en fusionarse con
          LUCKYPLATA.
        </p>
        <p>
          <span class="title">E. </span>Con nuestros socios comerciales, para fines de prospección comercial y servicios
          relacionados ofrecidos por LUCKYPLATA y para darte acceso a los servicios de terceros dentro de la aplicación
          de LUCKYPLATA.
        </p>
        <p>
          Asimismo, y de acuerdo con las leyes vigentes, LUCKYPLATA deberá, con el objeto de cumplir con las Finalidades
          Primarias descritas en el presente, transferir de tiempo en tiempo, información de crédito del Titular a las
          Sociedades de Información Crediticia o Burós de Crédito, y en este sentido, al aceptar el presente Aviso de
          Privacidad (en lo sucesivo, este “Aviso”) y al consentir a la celebración del Contrato de Usuario, usted
          confirma que podemos transmitir su información a dichas Sociedades de Información Crediticia o Burós de
          Crédito, incluyendo información sobre el incumplimiento a los contratos celebrados entre el Titular y
          LUCKYPLATA, entre otros el Contrato del Usuario.
        </p>
        <p>
          También compartimos tus datos personales con terceros prestadores de servicios relacionados con los
          desembolsos, la transferencia de fondos, servicios de pagos, proveedores de seguridad de información,
          aseguradoras, despachos de cobranza, asesores contables y legales, proveedores de software para análisis de
          datos, transferencias y servicios de almacenamiento y otros prestadores de servicios que procesan tus datos
          personales por cuenta de LUCKYPLATA.
        </p>
        <p class="title">TUS DERECHOS ARCO</p>
        <p>
          Tú, por ti mismo o mediante tu representante legal debidamente acreditado, puedes ejercer tus derechos de
          acceso, rectificación, cancelación u oposición al tratamiento de tus datos personales (los “Derechos ARCO”).
          Para ello podrás solicitar un formato de ejercicio de Derechos ARCO mediante el envío de un correo electrónico
          a la dirección luckyplataatc@gmail.com, en atención de Departamento de Protección de Datos Personales/Equipo
          de Atención al Cliente, al número telefónico +57 3042345034 o bien a la dirección de LUCKYPLATA indicada en
          este Aviso con el nombre y los datos de contacto del Titular.
        </p>
        <p>
          El formato de ejercicio de Derechos ARCO se deberá llenar, firmar y presentarse acompañado de la siguiente
          documentación, a fin de que pueda llevarse a cabo la autenticación de usted:
        </p>
        <p>
          1. Tu identificación oficial vigente (Credencial del Instituto Nacional Electoral, Pasaporte, Cartilla del
          servicio Militar Nacional o Cédula Profesional).
        </p>
        <p>
          2. En los casos en que el ejercicio de los Derechos ARCO se realice a través de tu representante legal, deberá
          acompañarse la identificación oficial del representante, así como el poder correspondiente protocolizado que
          acredite la representación legal conferida por el Titular.
        </p>
        <p>
          3. Cuando se quiera ejercer el derecho de rectificación, deberá exhibirse la documentación que acredite el
          cambio solicitado de acuerdo a los datos personales a rectificar.
        </p>
        <p>
          LUCKYPLATA responderá a dicho formato después de 20 días hábiles contados a partir de la fecha en que fue
          recibido el mismo. Este plazo podrá ser ampliado hasta por 20 días hábiles más, cuando el caso lo amerite,
          previa notificación a usted. LUCKYPLATA le comunicará la resolución adoptada a través de las opciones elegidas
          por éste en el formato de ejercicio de Derechos ARCO.
        </p>
        <p class="title">PUEDES NEGARTE O REVOCAR EL CONSENTIMIENTO PARA TRATAR TUS DATOS</p>
        <p>
          En caso de que desees revocar tu consentimiento o negarte al tratamiento de tus datos personales para las
          Finalidades Secundarias, con posterioridad a la firma y aceptación del presente Aviso, deberás enviar un
          correo electrónico a la dirección indicada en la sección anterior al Departamento de Protección de Datos
          Personales/Equipo de Atención al Cliente, luckyplataatc@gmail.com, siguiendo el procedimiento para la Negativa
          al Tratamiento y Revocación del Consentimiento que se describe en este Aviso.
        </p>
        <p>
          De acuerdo con lo anterior, el Departamento de Protección de Datos Personales/Equipo de Atención al Cliente es
          el encargado de atender todas las solicitudes de ejercicio de los derechos ARCO (acceso, rectificación,
          cancelación u oposición) mismo que puedes contactar en caso de cualquier duda o solicitud con respecto a tus
          datos personales a través del correo electrónico y teléfono antes indicados.
        </p>
        <p class="title">¿QUÉ MEDIOS TIENES PARA LIMITAR EL USO Y DIVULGACIÓN DE DATOS PERSONALES?</p>
        <p>
          LUCKYPLATA ha creado un listado de exclusión para personas que no deseen recibir publicidad de LUCKYPLATA. Si
          recibes publicidad de LUCKYPLATA y no deseas seguir recibiéndola, podrás enviar un correo electrónico con tu
          nombre completo a luckyplataatc@gmail.com, solicitando tu eliminación de la lista de distribución con base en
          la cual se lleva a cabo el envío de la información o publicidad. En el mismo correo electrónico podrás
          solicitar más datos acerca de este listado.
        </p>
        <p class="title">CONTACTOS</p>
        <p>Correo electrónico: <span style="color: #0000ff">luckyplataatc@gmail.com</span></p>
        <p>
          Página web:
          <span style="color: #0000ff">https://www.luckyplata.co/</span> – Sección “Contáctenos”.
        </p>
        <p>Teléfono de atención al cliente: +57 3042345034</p>
        <p>Horario de Atención:L-V 8:00 a 17:00; S 8:00 a 12:00</p>
        <p class="title">CAMBIOS AL AVISO DE PRIVACIDAD</p>
        <p>
          El presente Aviso se encuentra publicado para su consulta, en la página de Internet de LUCKYPLATA (<span
            style="color: #0000ff">https://www.luckyplata.co</span>). De igual forma, las modificaciones que en
          cualquier momento se hagan al presente Aviso, serán publicadas
          en dicha dirección.
        </p>
        <p>
          Al hacer clic en el botón “ACEPTAR” al calce, el Titular otorga su consentimiento expreso en términos del
          presente Aviso y por ende, consiente que sus Datos Personales sean tratados por LUCKYPLATA conforme a lo
          previsto en el presente Aviso, destinados para las finalidades indicadas en el presente y transferidos a los
          terceros establecidos aquí indicados.
        </p>
        <p class="title">DECISIONES AUTOMATIZADAS</p>
        <p>
          Tomamos algunas decisiones en relación con nuestros productos y servicios en forma automatizada sin
          intervención de una persona física en la valoración.
        </p>
        <p class="title">I. Decisiones de otorgar préstamos</p>
        <p>
          Cuando solicitas un préstamo, usaremos un proceso automatizado para decidir si prestamos dinero y/o para toma
          de decisiones respecto a tu elegibilidad para nuestros productos o servicios.
        </p>
        <p>
          Nuestros procesos de revisión y otorgamiento de crédito utilizan inteligencia artificial para procesar tus
          datos personales y valorar tu capacidad crediticia. El tratamiento de tus datos personales es automatizado sin
          intervención o valoración humana. El uso de dichos procesos automatizados para verificar tu capacidad
          crediticia significa que podemos automáticamente decidir que no eres elegible para un préstamo o para un plazo
          o condiciones particulares. Nuestros modelos de suscripción y otorgamiento de crédito son probados
          regularmente para asegurarnos que son justos, exactos y sin prejuicios.
        </p>
        <p class="title">II. Detección de fraudes</p>
        <p>
          LUCKYPLATA también utiliza procesos automatizados para detectar, combatir y prevenir fraudes. Nuestros modelos
          de detección de fraudes automáticamente deciden si una persona puede significar riesgo de fraude o lavado de
          dinero. Si nuestros modelos de detección de fraude al procesar una transacción o aprobar un crédito detectan
          riesgo, es posible que el acceso a la persona se rehuse.
        </p>
        <p class="title">III. Tus derechos</p>
        <p>
          Si solicitas un crédito y eres rechazado basado en una decisión automatizada, tienes derecho a acceder a tu
          información y rectificarla contactándonos como se establece en la sección Derechos ARCO.
        </p>
      </div>
    </div>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from '@/components/headNav.vue'
import footPage from '@/components/foot.vue'
import '../components/scss/Aviso.scss'

export default {
  name: 'Aviso',
  components: { headNav, footPage },
  data () {
    return {}
  },
}
</script>

<style scoped>
.Aviso p {
  margin-bottom: 20px;
  font-size: 16px;
}

.p-bottom {
  margin-bottom: 0 !important;
}

.title {
  font-size: 16px;
  margin-top: 15px;
  font-weight: 600;
}
</style>
